import { CopyOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd-v4'
import React, { PropsWithChildren } from 'react'
import { copyStrToClipboard } from '../utilities/helpers'
import classNames from 'classnames'
import { TooltipProps } from 'antd-v4/lib/tooltip'

interface BaseProps {
  text: string
  tooltipProps?: Omit<TooltipProps, 'overlay'>
  className?: string
  afterSuccess?: (text: string) => void
  afterFail?: (e: Error) => void
}

interface PropsWithIcon extends BaseProps {
  iconStyle?: React.CSSProperties
}

const CopyToClipboardWrapper = (props: PropsWithChildren<BaseProps>) => {
  return (
    <Tooltip title={`Click to copy "${props.text}"`} {...props.tooltipProps}>
      {props.children as any}
    </Tooltip>
  )
}

export const CopyToClipboardWithIcon = (props: PropsWithIcon) => {
  return (
    <CopyToClipboardWrapper {...props}>
      <CopyOutlined
        className={classNames(props.className, 'cursor-pointer')}
        style={props.iconStyle}
        onClick={(e) => {
          e.stopPropagation()
          copyStrToClipboard(props.text, props.afterSuccess, props.afterFail)
        }}
      />
    </CopyToClipboardWrapper>
  )
}

interface PropsWithoutIcon extends BaseProps {
  title: string
}

export const CopyToClipboard = (props: PropsWithoutIcon) => {
  return (
    <CopyToClipboardWrapper {...props}>
      <div
        className={classNames(props.className, 'cursor-pointer')}
        onClick={(e) => {
          e.stopPropagation()
          copyStrToClipboard(props.text, props.afterSuccess, props.afterFail)
        }}
      >
        {props.title}
      </div>
    </CopyToClipboardWrapper>
  )
}
